import styled from 'styled-components';
import { Link } from 'gatsby';

export default styled(Link)`
  margin-bottom: 1rem;

  img {
    max-width: 100%;
    border-radius: .25rem;
  }
`;
